import { PathGroup } from '../api/path-group';

export const Paths: PathGroup = {
    base: '/uk-UA/',
    contact: 'контакт',
    fees: 'тарифи',
    rodo: 'захист-персональних-даних',
    notarialActivities: {
        base: 'нотаріальні-діяльності',
        inheritanceLaw: 'спадкове-право',
        familyLaw: 'сімейне-право',
        realEstate: 'нерухомість',
        certificates: 'бізнес-та-інші-операції',
    }
}
